/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([scale=s]) {
  --calcite-internal-stepper-item-spacing-unit-s: 0.25rem;
  --calcite-internal-stepper-action-block-size: 2.75rem;
  --calcite-internal-stepper-action-inline-size: 2rem;
  --calcite-internal-step-bar-gap: 0.25rem;
}

:host([scale=m]) {
  --calcite-internal-stepper-item-spacing-unit-s: 0.5rem;
  --calcite-internal-stepper-action-block-size: 3.25rem;
  --calcite-internal-stepper-action-inline-size: 2.5rem;
}

:host([scale=l]) {
  --calcite-internal-stepper-item-spacing-unit-s: 0.75rem;
  --calcite-internal-stepper-action-block-size: 4rem;
  --calcite-internal-stepper-action-inline-size: 3rem;
  --calcite-internal-step-bar-gap: 0.75rem;
}

:host {
  display: flex;
}

.container {
  position: relative;
  display: flex;
  inline-size: 100%;
  min-inline-size: -moz-fit-content;
  min-inline-size: fit-content;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
}

:host([layout=vertical]) .container {
  flex: 1 1 auto;
  flex-direction: column;
}

:host([layout=horizontal]) .container,
:host([layout=horizontal-single]) .container {
  display: grid;
  grid-template-areas: "items" "content";
  gap: 0.5rem var(--calcite-internal-stepper-item-spacing-unit-s);
}

:host([layout=horizontal][scale=s]) .container,
:host([layout=horizontal-single][scale=s]) .container {
  gap: 0.25rem var(--calcite-internal-stepper-item-spacing-unit-s);
}

:host([layout=horizontal][scale=l]) .container,
:host([layout=horizontal-single][scale=l]) .container {
  gap: 0.75rem var(--calcite-internal-stepper-item-spacing-unit-s);
}

:host([layout=horizontal]) .container.single-view {
  display: flex;
  grid-template-columns: none;
}

.action-icon {
  position: relative;
  display: flex;
  flex-grow: 0;
  block-size: var(--calcite-internal-stepper-action-block-size);
  inline-size: var(--calcite-internal-stepper-action-inline-size);
}

.action-container {
  position: absolute;
  display: flex;
  justify-content: space-between;
  padding-block: 0.25rem;
  inline-size: 100%;
}

.step-bar {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
}

.step-bar-container {
  position: absolute;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  block-size: 0.125rem;
  inline-size: 100%;
  gap: var(--calcite-internal-step-bar-gap, 0.5rem);
}

.step-bar--inactive {
  fill: var(--calcite-color-border-3, #dfdfdf);
  fill-opacity: 1;
  block-size: 100%;
}

.step-bar--active {
  fill: var(--calcite-color-brand);
}

.step-bar--complete {
  fill: var(--calcite-color-brand);
  fill-opacity: 0.5;
}

.step-bar--error {
  fill: var(--calcite-color-status-danger);
}

.step-bar--disabled {
  opacity: 0.5;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}